export async function getFavicon(websiteUrl: string): Promise<File | null> {
  try {
    // Normalize URL (prepend https:// if missing)
    let url: URL;
    try {
      url = new URL(websiteUrl);
    } catch (error) {
      url = new URL(`https://${websiteUrl}`);
    }
    const hostname = url.hostname;
    const origin = url.origin;

    // Define candidate URLs in order of preference.
    const candidateUrls = [
      `https://www.google.com/s2/favicons?domain=${hostname}&sz=64`,
      `https://api.faviconkit.com/${hostname}/64`,
      `${origin}/favicon.ico`
    ];

    // For the Google and FaviconKit services, enforce a minimum blob size (in bytes).
    const MIN_BLOB_SIZE = 50;

    // Helper function: Try to fetch a blob from a given candidate URL.
    const fetchBlob = async (candidate: string): Promise<Blob | null> => {
      try {
        const response = await fetch(candidate, { mode: 'cors' });
        if (!response.ok) return null;
        const blob = await response.blob();
        // For Google and FaviconKit, skip candidates that return a tiny blob.
        if (candidate !== `${origin}/favicon.ico` && blob.size < MIN_BLOB_SIZE) {
          return null;
        }
        return blob;
      } catch (error) {
        console.error(`Error fetching blob from ${candidate}:`, error);
        return null;
      }
    };

    // Try each candidate in order and return the first valid favicon found.
    for (const candidate of candidateUrls) {
      const blob = await fetchBlob(candidate);
      if (blob) {
        // Determine an appropriate file extension based on the MIME type.
        let extension = 'png';
        if (blob.type === 'image/svg+xml') {
          extension = 'svg';
        } else if (blob.type === 'image/x-icon') {
          extension = 'ico';
        }
        return new File([blob], `${hostname}-favicon.${extension}`, { type: blob.type });
      }
    }

    console.warn(`No valid favicon found for ${websiteUrl}`);
    return null;
  } catch (error) {
    console.error(`Error in getFavicon for ${websiteUrl}:`, error);
    return null;
  }
}
